<template>
  <div>
    <router-link
      v-slot="{ route: lroute }"
      :to="href"
      custom
    >
      <li
        :class="[hidden ? 'hidden' : '', disabled ? 'text-gray-300 cursor-not-allowed' : isActive ? 'bg-stone-200 hover:bg-blue-50 text-gray-900' : 'text-gray-600 hover:bg-stone-200/50 hover:text-gray-600', 'cursor-pointer group flex items-center px-2 py-1.5 text-base font-medium rounded-md']"
        @click="go(lroute)"
      >
        <template v-if="loading">
          <stormy-spinner-small
            :size="5"
            class="mr-1.5 text-blue-500"
          />
        </template>
        <div
          v-else
          class="flex-none"
        >
          <stormy-icon
            :name="icon"
            :class="[disabled ? 'text-gray-300 cursor-not-allowed' : active ? 'text-gray-400' : 'text-black group-hover:text-gray-900', 'flex-shrink-0 mr-1.5 h-5 w-5 ']"
            :stroke-width="strokeWidth"
          />
        </div>
        <span
          class="truncate flex-1"
          :class="[disabled ? 'text-gray-300 cursor-not-allowed' : '', isActive ? 'text-green-900' : 'text-gray-600']"
        >
          {{ name }}
        </span>
        <template
          v-if="!disabled && info"
        >
          <div class="text-sm flex-none text-right font-normal text-gray-600">
            {{ info }}
          </div>
        </template>
        <template
          v-if="!disabled && count"
        >
          <StormyStatusDot
            :animate="animate"
            :color="color"
            class="ml-auto text-right mr-4"
          />
        </template>
        <div
          v-if="hasAction"
          class="flex-none"
        >
          <div class="hidden group-hover:block">
            <slot name="action" />
          </div>
        </div>
      </li>
    </router-link>
    <div
      v-if="!loading && (hasChilds && (!disabled && (isActive || open)))"
      class="text-sm ml-5 my-2 font-normal text-gray-400 space-y-2"
    >
      <slot />
    </div>
  </div>
</template>

<script setup>
import { computed, useSlots } from 'vue'
import { useProp } from '@/composables/useProp.js'
import { useRouter, useRoute } from 'vue-router'

const routerRoute = useRoute()
const router = useRouter()

const props = defineProps({
  name: useProp(String),
  icon: useProp(String),
  count: useProp(String, ''),
  color: useProp(String, 'red'),
  disabled: useProp(Boolean, false),
  hidden: useProp(Boolean, false),
  exact: useProp(Boolean, false),
  active: useProp(Boolean, false),
  animate: useProp(Boolean, false),
  open: useProp(Boolean, false),
  strokeWidth: useProp(Number, 1.5),
  info: useProp(String, ''),
  loading: useProp(Boolean, false),
  route: useProp(Object),
  activeRouteName: useProp(String)
})

const $slots = useSlots()

const hasAction = computed(() => {
  return $slots.action
})

const hasChilds = computed(() => {
  return $slots.default
})

const translatedLabel = computed(() => props.i18n ? $t(props.name) : props.name)

const href = computed(() => {
  try {
    const newRoute = router.resolve(props.route)
    return newRoute.href
  } catch (error) {
    console.log(error)
    return ''
  }
})

const go = (nRoute) => {
  if (!props.disabled && nRoute.fullPath !== routerRoute.fullPath) {
    router.push(nRoute)
  }
}
const isActive = computed(() => {
  const currentRoute = routerRoute.path
  if (props.activeRouteName) {
    return currentRoute.startsWith(props.activeRouteName)
  }

  return currentRoute === href.value
})
</script>
